// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"5d5d1b7f","317":"8641c6dc","811":"e028cbe3","818":"5d5d1b7f","893":"5d5d1b7f","898":"5d5d1b7f","926":"5d5d1b7f"}[chunkId] + ".chunk.css";
};